<template>
  <div class="expertOnlineList">
    <!-- 搜索 -->
    <div class="searchBox">
      <span class="gobackBtn" @click="goBack" v-show="!isCancelExpert">
        <van-icon name="arrow-left" />
      </span>
      <van-search :left-icon='require("../../../assets/images/icon/search.png")' class="vanSearch" :class="[isCancelExpert?'vanSearch1':'vanSearch2']" v-model="searchText" placeholder="开始搜索，从新妈变星妈" shape="round"  @focus="searchFocus($event)" />
    </div>
    <!-- 搜索记录、为您推荐 -->
    <!-- <layer-float :recordList="recordList" v-show="!layerFloatShowExpert" :searchIndex="'expertOnline'"></layer-float> -->
    <!-- 搜索关键词联动 -->
    <!-- <div class="search_wordList">
            <ul class="word_list">
                <li><span class="icon"></span><p><span style="color:#F1BE46;">宝宝</span>护理</p></li>
                <li><span class="icon"></span><p><span style="color:#F1BE46;">宝宝</span>护理</p></li>
                <li><span class="icon"></span><p><span style="color:#F1BE46;">宝宝</span>不爱吃饭</p></li>
                <li><span class="icon"></span><p><span style="color:#F1BE46;">宝宝</span>什么时候开口说话？</p></li>
                <li><span class="icon"></span><p><span style="color:#F1BE46;">宝宝</span>护理</p></li>
            </ul>
    </div>-->
    <!-- 专家在线二级列表页 -->
    <div v-show="layerFloatShowExpert" class="expert-content">
      <div class="touchBox">
        <!-- 权威医师 -->
        <div class="expert_list" v-if=" expertList && expertList.length != 0">
          <h1 class="module_title">
            权威医师
            <span>
              <router-link :to="{name: 'expertLists'}">
                全部({{expertAllnum}})
                <van-icon name="arrow" />
              </router-link>
            </span>
          </h1>
          <div class="my_swiper">
            <mySwiper v-if="expertList.length != 0" :slidesNum="2.9" :loop="false" :spaceBetweenNum="12" :swipeid="'experts_online_swiper'">
              <div class="swiper-slide" @click="toExpertList(item,index)" slot="swiper-con" :key="item.id" v-for="(item,index) in expertList">
                <div class="imgCon" v-lazy:background-image="item.headImageUrl"></div>
                <div class="con">
                  <div class="tit">{{item.name}}</div>
                  <div class="info">{{item.companyName}}{{item.title}}</div>
                </div>
              </div>
              <div class="swiper-slide swiper-slide1" @click="toExpertList(-1)" slot="swiper-con">
                <img src="../../../assets/images/expert/ex_more.png" alt />
              </div>
            </mySwiper>
          </div>
        </div>
        <!-- 问题列表 -->
        <van-tabs v-model="curTagId" class="expert_question_box" animated sticky :swipe-threshold="3.5" @click="switchPage" title-inactive-color="#333333" title-active-color="#333333" line-height="3px" line-width="36px" :duration="0" color="#FF67C1">
          <van-tab :key="item.id" :name="item.fnTagId" v-for="item in tagList" :title="item.name" :class="'question_course questions questionsList'+item.fnTagId">
            <van-list class="ex_question_list" v-model="expertListLoading" :finished="expertListFinished" :finished-text="finishText" :error.sync="expertListError" error-text="请求失败，点击重新加载" @load="getList(switchTagId)">
              <div :key="expert.id" class="question_list" v-for="(expert, index) in expertAnswerList">
                <div @click="toExpertDetail(expert,item)">
                  <h3 class="title">
                    <span v-if="expert.isViewsHot" class="hot"></span>
                    <span v-if="expert.isSeasonHot" class="season"></span>
                    {{expert.question}}
                  </h3>
                  <div class="expert_info" @click.stop="toExpertInfo(expert)" v-if="expert.expert">
                    <span class="tx" v-lazy:background-image="expert.expert.headImageUrl"></span>
                    <div class="ex_right">
                      <span class="name">{{expert.expert.realName}}</span>
                      <br />
                      <span class="position">{{expert.expert.hospital}}{{expert.expert.position}}</span>
                    </div>
                  </div>
                  <p class="content">{{expert.answer}}</p>
                  <p class="read_collect">
                    <span>{{fomatterNum(expert.pageViews)}}妈妈看过</span>
                    <span>{{fomatterNum(expert.pageCollection)}}收藏</span>
                  </p>
                </div>
              </div>
            </van-list>
          </van-tab>
        </van-tabs>
        <!-- 分类下拉按钮 -->
        <span class="tag_slide tag_down" @click="packUp('down')"></span>
        <!-- 在线专属顾问 -->
        <div class="online_btn" :class="{'online_btn2': !onlineBtnShow}" @click="contactServiceHander">
          <img src="../../../assets/images/icon/callHome.png" alt />
          <span v-show="onlineBtnShow">专属客服</span>
        </div>
        <!-- 返回顶部 -->
        <to-top></to-top>
      </div>
      <!-- 全部分类列表<span class="tag" :key="item.id" @click.stop="switchPageList(item.fnTagId)" v-for="item in tagList" :class="item.id==curTagId ? 'hotTag':''">{{item.name}}</span> -->
      <div class="tagAllListMask" @click.stop="packUp('up')">
        <div class="tagAllList">
          <p class="tagAlltitle">
            分类
            <span @click.stop="packUp('up')">
              <van-icon name="arrow-up" />
            </span>
          </p>
          <div class="class-list">
            <div class="list-wrap" v-for="(item,index) in tagListTitle" :key="index">
              <div class="big-title">{{item.fnTagId!=0?item.name:''}}</div>
              <div :class="item.fnTagId==curTagId ? 'hotTag small-title':''||item.fnTagId == 0?'small-title':''" @click="switchPageList(item)">{{item.fnTagId == 0?item.name:''}}</div>
              <div class="small-title" v-for="(items,index) in item.tagList" @click="switchPageList(items)" :key="index" :class="items.fnTagId==curTagId ? 'hotTag':''">{{items.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less">
// .expertOnlineList{
//   position: fixed;
//   left:0; top:0; width:100%; height:100%; overflow: auto;
//   -webkit-overflow-scrolling: touch
// }
.van-field__body {
  position: relative;
  top: 1px;
}
.expertOnlineList {
  min-height: 100%;
  padding-top: 58px;
  // position: relative;
  // 搜索
  .searchBox {
    width: 100%;
    background: @expertFontColor255;
    overflow: hidden;
    position: fixed;
    padding-bottom: 12px;
    top: 0;
    left: 0;
    z-index: 98;
    .van-search {
      width: 90%;
      padding: 12px 0 0 12px;
      font-size: @indexFontSize12;
      float: left;
      .van-search__action {
        padding: 0 12px;
        font-size: @indexFontSize14;
      }
      .van-field__control{
          padding-left: 2px;
      }
    }
    .vanSearch1 {
      width: 89%;
      padding: 12px 0 0 12px;
    }
    .vanSearch2 {
      width: 90%;
      padding: 12px 0 0 0;
    }
    @media screen and (max-width: 640px) {
      .vanSearch1 {
        width: 87%;
      }
      .vanSearch2 {
        width: 326px;
      }
    }
    span.canBtn {
      display: inline-block;
      float: right;
      font-size: @indexFontSize14;
      color: @expertFontColor51;
      padding: 20px 12px 10px 7px;
    }
    span.gobackBtn {
      width: 20px;
      height: 20px;
      display: inline-block;
      float: left;
      font-size: @indexFontSize20;
      color: @expertFontColor51;
      padding: 18px 10px 0 7px;
      .van-icon {
        float: left;
        vertical-align: middle;
      }
    }
  }
  // 搜索关键词联动
  .search_wordList {
    padding: 5px 26px 30px 12px;
    background: @expertFontColor255;
    .word_list {
      width: 100%;
      li {
        overflow: hidden;
        span.icon {
          width: 13px;
          height: 46px;
          display: inline-block;
          float: left;
        }
        p {
          width: 322px;
          height: 46px;
          line-height: 46px;
          font-size: @indexFontSize14;
          border-bottom: 1px solid @expertBorderColor242;
          float: left;
        }
      }
      li:last-child {
        p {
          border-bottom: 0;
        }
      }
    }
  }
  // 权威医师
  .expert_list {
    background: @expertFontColor255;
    padding-top: 8px;
    border-bottom: 8px solid @expertBorderColor242;
    .module_title {
      color: @expertFontColor51;
      font-size: @indexFontSize18;
      padding: 0 12px;
      line-height: 18px;
      font-weight: bold;
      span {
        float: right;
        a {
          height: 12px;
          color: #333;
          display: block;
          font-size: @indexFontSize12;
          line-height: 1;
          .van-icon {
            vertical-align: bottom;
            font-size: @indexFontSize12;
          }
        }
      }
    }
    .my_swiper {
      padding: 20px 0 20px 12px;
      overflow: hidden;
      /deep/ .swiper-container {
        overflow: hidden !important;
      }
    }
  }
  // 标签下拉按钮
  .tag_slide {
    width: 22px;
    height: 20px;
    text-align: center;
    font-size: @indexFontSize12;
    display: inline-block;
    position: absolute;
    bottom: 10px;
    right: 12px;
  }
  .tag_down {
    background: url(../../../assets/images/icon/down.png) no-repeat center right;
    background-size: 14px 8px;
    display: none;
  }
  // 问题列表
  .expert_question_box {
    width: 100%;
    display: none;
    .van-tabs__content {
      background: @expertBorderColor242;
    }
    .van-tabs__wrap {
      position: relative;
      background: @expertFontColor255;
    }
    .van-hairline--top-bottom::after {
      border-top: 0;
    }
    .van-tabs__nav {
      margin-right: 34px;
      margin-left: 12px;
      .van-tab {
        line-height: 50px;
        font-size: @indexFontSize14;
        font-weight: 500;
      }
      .van-tab--active {
        font-size: @indexFontSize16;
        font-weight: bold;
      }
    }
    .questions {
      .ex_question_list {
        .question_list {
          padding: 16px 12px;
          border-bottom: 1px solid @expertBorderColor242;
          background: @expertFontColor255;
          .title {
            font-size: @indexFontSize15;
            font-weight: 500;
            color: @expertFontColor51;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin-bottom: 14px;
            line-height: 22px;
            span {
              width: 27px;
              height: 14px;
              margin-right: 5px;
              display: inline-block;
              vertical-align: middle;
            }
            span.hot {
              background: url(../../../assets/images/icon/hot.png) no-repeat
                center center;
              background-size: 100% 14px;
            }
            span.season {
              background: url(../../../assets/images/icon/season.png) no-repeat
                center center;
              background-size: 100% 14px;
            }
          }
          .expert_info {
            overflow: hidden;
            margin-bottom: 10px;
            .tx {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #eee;
              display: inline-block;
              margin-right: 3px;
              background-position: center center;
              background-repeat: no-repeat;
              background-size: cover;
              float: left;
            }
            .ex_right {
              width: 85%;
              float: left;
              font-size: @indexFontSize12;
              line-height: 18px;
              margin-top: 2px;
              .name {
                width: 100%;
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
              }
              .position {
                width: 100%;
                color: #999999;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
              }
            }
          }
          .content {
            max-height: 61px;
            font-size: @indexFontSize14;
            font-weight: 400;
            color: @expertFontColor102;
            line-height: 22px;
            margin-bottom: 12px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .read_collect {
            text-align: right;
            font-size: @indexFontSize12;
            font-weight: 400;
            color: @expertFontColor153;
            line-height: 12px;
            span {
              padding-left: 10px;
            }
          }
        }
        .question_list:last-child {
          border-bottom: 0;
        }
        .bottom_line {
          width: 100%;
          text-align: center;
          font-size: @indexFontSize12;
          font-weight: 400;
          color: @expertFontColor153;
          float: left;
          padding: 40px 0;
          background: @expertBorderColor242;
          display: none;
        }
        // 数据加载中
        .loading {
          text-align: center;
          font-size: @indexFontSize14;
          padding: 12px 0;
          background: @expertBorderColor242;
        }
      }
    }
  }
  // 全部分类列表
  .tagAllListMask {
    width: 100%;
    height: 100%;
    background: @expertColorMask;
    position: fixed;
    top: 46px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99;
    display: none;
    .tagAllList {
      background: @expertFontColor255;
      .tagAlltitle {
        padding: 20px 12px 10px 12px;
        font-size: 16px;
        font-weight: bold;
        color: @expertFontColor51;
        line-height: 16px;
        display: flex;
        justify-content: space-between;
        span {
          width: 15px;
          height: 8px;
        }
      }
      .class-list {
        padding: 0 12px;
        font-size: 14px;
        font-weight: 400;
        color: @expertFontColor51;
        line-height: 14px;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        .list-wrap {
          width: 100%;
          .hotTag {
            color: #FF67C1;
          }
          .big-title {
            padding-bottom: 12px;
            color: #333;
            font-size: 14px;
            font-weight: bold;
            line-height: 16px;
          }
          .small-title {
            display: inline-flex;
            padding: 8px 12px;
            text-align: center;
            background: @expertBorderColor242;
            border-radius: 15px;
            margin-right: 12px;
            margin-bottom: 20px;
          }
        }
        .active {
          color: #d4a437;
        }
        .tag {
          padding: 8px 12px;
          text-align: center;
          background: @expertBorderColor242;
          border-radius: 15px;
          margin-right: 12px;
          margin-bottom: 20px;
        }
      }
    }
  }
  // 在线专属顾问
  .online_btn {
    width: 110px;
    height: 44px;
    background: linear-gradient(
      90deg,
      rgba(246, 210, 123, 1) 0%,
      rgba(236, 179, 89, 1) 100%
    );
    border-radius: 24px;
    text-align: center;
    font-size: @indexFontSize14;
    color: @expertFontColor255;
    line-height: 44px;
    position: fixed;
    bottom: 100px;
    right: 12px;
    z-index: 98;
    transition: all 0.2s ease-in-out;
    img {
      margin-top: -1px;
      // width: 22px;
      height: 20px;
      vertical-align: middle;
      // vertical-align: -webkit-baseline-middle;
      // margin-left: 14px;
    }
    span {
      line-height: 44px;
      margin-left: 1px;
    }
  }
  .online_btn2 {
    width: 54px;
    height: 54px;
    background: linear-gradient(
      93deg,
      rgba(246, 210, 122, 1) 0%,
      rgba(237, 182, 92, 1) 100%
    );
    border-radius: 50%;
    img {
      // width: 22px;
      // height: 23px;
      transform: scale(1.2);
      vertical-align: -webkit-baseline-middle;
      // vertical-align: middle;
    }
  }
}
</style>

<script>
import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
import {
  fomatterNum,
  contactService,
  getCookie,
  is_weixin,
  isUserLogin,
} from "@/assets/js/common.js";
import layerFloat from "@/components/contents/searchCommon/history.vue";
import toTop from "@/components/common/toTop.vue";
import { log } from 'console';
export default {
  name: "expertOnlineList",
  components: {
    mySwiper,
    layerFloat,
    toTop
  },
  data () {
    return {
      curTagId: null, //当前所选分类
      switchTagId: parseInt(this.$route.query.tagId) || 0,
      curTagIdFlag: true,
      expertList: [], //专家列表集合
      expertAllnum: "0", //专家数量
      tagList: [], //问答分类列表
      expertAnswerList: [], //根据分类获取问答集合
      expertAnswerParams: {
        size: 25,
        page: 0,// 1,
        total: 0,
        flag: true
      },
      searchText: "", //当前搜索关键词
      recordList: "",
      layerFloatShowExpert: true, //搜索记录显示
      islayerFloatExpert: false,
      isCancelExpert: false,
      searchWordShow: true, //搜索关键词显示
      onlineBtnShow: true, //专家在线按钮
      direction: "down",
      expertListLoading: false,
      expertListFinished: false,
      finishText: "",
      expertListError: false,
      winScrollTop: 0,
      tabClassId: "",
      tagListTitle: [],
      tagsName: "精选问答"
    };
  },
  activated () {
    // this.curTagId = this.$route.query.tagId
    // this.switchPage(this.curTagId)
    // this.getExpertlist();
    // this.getTagList();
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit("changeIncludes", ["home", "expertOnlineList"]);
    });
  },
  beforeRouteLeave (to, from, next) {
    if (to.name == "questionDetail") {
      this.$store.commit("changeIncludes", [
        "expertOnlineList",
        "expertDetail",
        "home"
      ]);
    }

    next();
  },
  mounted () {
    let self = this;
    gio("page.set", { menu_pvar: "专家在线" });
    this.getExpertlist();
    this.getTagList();
    var startY;
    var endY;
    $(".touchBox")[0].addEventListener("touchstart", function (e) {
      var e = e || window.event;
      startY = e.touches[0].clientY;
    });
    $(".touchBox")[0].addEventListener("touchend", function (e) {
      if ($(e.target).parents(".mySwiper").length != 0) {
      } else {
        var e = e || window.event;
        endY = e.changedTouches[0].clientY;
        if (endY - startY > 0) {
          //上滑
          if (
            $(window).scrollTop() >
            document.getElementsByClassName("expert_question_box")[0]
              .offsetTop /
            (375 / $("body")[0].clientWidth)
          ) {
            $(".searchBox").css("position", "fixed");
            $(".van-sticky").css(
              "top",
              46 / (375 / $("body")[0].clientWidth) + "px"
            );
            this.direction = "down";
          } else if (
            $(window).scrollTop() <
            document.getElementsByClassName("expert_question_box")[0]
              .offsetTop /
            (375 / $("body")[0].clientWidth)
          ) {
            $(".searchBox").fadeIn(100);
            $(".van-sticky").css(
              "top",
              46 / (375 / $("body")[0].clientWidth) + "px"
            );
            $(".searchBox").css("position", "fixed");
            $(".van-sticky").css("top", "0px");
          }
        } else {
          if (endY - startY < 0) {
            //下滑
            self.onlineBtnShow = false;
            $(".van-sticky").css(
              "top",
              46 / (375 / $("body")[0].clientWidth) + "px"
            );
            $(".searchBox").css("position", "fixed");
            // $(".van-sticky").css("top","0px");
            this.direction = "up";
          }
        }
      }
    });
    var shareDataParams = {
      shareLink: location.href.split("#")[0],
      shareDesc: "汇聚全国知名母婴专家，你的问题专家为你解惑",
      shareTitle: "星妈会-专家在线",
      imgUrl: "https://image-mom.feihe.com/wxshare/home.png" //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
    //监听滚动条滚动
    $(window).scroll(this.inputBlur);
  },
  methods: {
    isUserLogin,
    fomatterNum, //格式化数字
    // 去掉小键盘
    inputBlur () {
      // $(".van-field__control").blur();
      if (this.onlineBtnShow && $(window).scrollTop() > 0) {
        this.onlineBtnShow = false;
      }
    },
    // 获取医生列表
    getExpertlist: function () {
      this.$http.post(
        "/author/getQAndAAuthorPageList",
        {},
        { page: 1, size: 10 },
        res => {
          if (res.code == 200) {
            this.expertList = res.data.data;
            this.expertAllnum = res.data.total;
            if (this.expertAllnum > 99) {
              this.expertAllnum = "99+";
            }
          }
        },
        err=>{
        },
        'lucky'
      );
    },
    // 点击医生卡片跳转到医生详情
    toExpertList: function (item, index) {
      if (item == -1) {
        this.$router.push({ path: "/expertOnline/expertLists" });
      } else {
        this.expertClickGio({
          floor_var: "权威医生",
          position_var: "专家坑位" + index,
          contentName_var: item.realName
        });
        var that = this;
        setTimeout(function () {
          that.$router.push({ path: "/expertOnline/expertLists/" + item.id });
        }, 200);
      }
    },
    // 获取分类列表
    getTagList: function () {
      this.$http.get("/expert/v3/expertTags", {}, res => {
        if (res.code == 200) {
          this.tagList = [{ name: "精选问答", id: 0, fnTagId: 0 }];
          this.tagListTitle = [{ name: "精选问答", id: 0, fnTagId: 0 }];
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].parentId == null) {
              this.tagListTitle.push(res.data[i]);
            }
            for (var j = 0; j < res.data[i].tagList.length; j++) {
              this.tagList.push(res.data[i].tagList[j]);
            }
          }
          $(".expert_question_box").css("display", "block");
          $(".van-tabs__wrap").append($(".tag_slide"));
          $(".tag_down").css("display", "block");
        }
      });
    },
    // 点击下拉所有分类
    packUp: function (type) {
      if (type == "down") {
        this.onlineBtnShow = false;
        $(".class-list").css(
          "max-height",
          document.body.clientHeight -
          $(".searchBox").outerHeight(true) -
          $(".tagAlltitle").outerHeight(true) +
          "px"
        );
        $(".van-tabs__content").css(
          "min-height",
          document.body.clientHeight -
          $(".van-sticky").height() -
          $(".searchBox").height() +
          "px"
        );
        $(".searchBox").fadeIn(100);
        $(".searchBox").css("position", "fixed");
        $(".tagAllListMask").fadeIn(100);
        $(".tagAllList")
          .delay(50)
          .slideDown(300);
        var top = document.getElementsByClassName("searchBox")[0].offsetHeight;
        this.winScrollTop = $(window).scrollTop();
        if (
          this.winScrollTop <=
          (document.getElementsByClassName("expert_question_box")[0].offsetTop -
            top) /
          (375 / $("body")[0].clientWidth)
        ) {
          this.winScrollTop =
            (document.getElementsByClassName("expert_question_box")[0]
              .offsetTop -
              top) /
            (375 / $("body")[0].clientWidth);
        }
        if (
          window.scrollY <
          document.getElementsByClassName("expert_question_box")[0].offsetTop
        ) {
          $("body").animate({
            top: -this.winScrollTop + "px"
          });
        }
        if (this.direction == "down") {
          $(".searchBox").fadeIn(100);
          $(".searchBox").css("position", "fixed");
        }
        $("body").css({
          position: "fixed",
          top: -this.winScrollTop + "px"
        });
        $(".van-sticky").css(
          "top",
          46 / (375 / $("body")[0].clientWidth) + "px"
        );
      } else {
        $(".tagAllList").slideUp(300);
        $(".tagAllListMask").fadeOut(100);
        $("body").css({ position: "initial", top: "auto" });
        $(window).scrollTop(this.winScrollTop);
      }
    },
    // load
    getList(id) {
      console.log(this.expertAnswerParams.page,'this.expertAnswerParams.page');
      this.expertAnswerParams.page += 1;
      this.getQuestionList(id)
    },
    // 根据分类获取问答列表
    getQuestionList: function (tagId) {
      var that = this;
      console.log(this.expertAnswerParams.page,'this.expertAnswerParams.page111');
      var question1 = "";
      var question2 = "";
      that.tagListTitle.forEach(item => {
        if (item.name == that.tagsName) {
          question1 = that.tagsName
          question2 = that.tagsName
        } else {
          if (item.tagList) {
            item.tagList.forEach(items => {
              if (items.name == that.tagsName) {
                if (items.name == '喂养攻略' || items.name == '转奶' || items.name == '断奶' || items.name == '营养补剂' || items.name == '奶粉喂养' || items.name == '母乳储存') {
                  question1 = '科学喂养'
                  question2 = items.name
                } else {
                  question1 = item.tagList[0].name
                  question2 = items.name
                }
              }
            });
          } else {
            question1 = that.tagsName
            question2 = that.tagsName
          }
        }
      });
      if (
        this.expertAnswerParams.total !=0 &&
        that.expertAnswerParams.page >=
        Math.ceil(this.expertAnswerParams.total / that.expertAnswerParams.size)
      ) {
        this.expertListFinished = true;
        this.finishText = "——已经到底了哦——";
        return
      }
      this.$http.post(
        "/expert/v3/expertAnswerListByType",
        { type: tagId },
        {
          data: {},
          page: that.expertAnswerParams.page,
          size: that.expertAnswerParams.size
        },
        res => {
          this.expertListLoading = false;
          if (this.curTagIdFlag) {
            this.curTagIdFlag = false;
            this.curTagId = this.$route.query.tagId || 0;
          }
          if (res.code == 200) {
            const list = that.expertAnswerList.map(item => item.id)
            res.data.content.map(item => {
              if(!list.includes(item.id)) {
                that.expertAnswerList.push(item)
              }
            })
            // that.expertAnswerList = that.expertAnswerList.concat(
            //   res.data.content
            // );
            this.expertAnswerParams.total = res.data.totalElements

            // if (
            //   that.expertAnswerParams.page >=
            //   Math.ceil(res.data.totalElements / that.expertAnswerParams.size)
            // ) {
            //   this.expertListFinished = true;
            //   this.finishText = "——已经到底了哦——";
            // } else {
            //   this.expertAnswerParams.page += 1;
            // }

            sensors.track("QuestionTabClickResult", {
              question_class1: question1,
              question_class2: question2,
              search_number: that.expertAnswerList.length,
              is_successful: true
            });
          } else {
            this.expertListLoading = false;
            this.expertListError = true;
            sensors.track("QuestionTabClickResult", {
              question_class1: question1,
              question_class2: question2,
              search_number: 0,
              is_successful: false
            });
          }
        },
        res => {
          this.expertListLoading = false;
          this.expertListError = true;
        }
      );
    },
    // 切换分类
    switchPage: function (name, title) {
      this.tagsName = title;
      if ($(".van-sticky").css("position") == "fixed") {
        $(".van-tabs__content").css(
          "min-height",
          document.body.clientHeight - $(".van-sticky").height() + "px"
        );
        if ($(".searchBox").css("position") == "fixed") {
          $(".van-tabs__content").css(
            "min-height",
            document.body.clientHeight -
            $(".van-sticky").height() -
            $(".searchBox").height() +
            "px"
          );
        }
      }
      this.tagList.forEach(item => {
        if (item.name == title) {
          this.tabClassId = item.fnTagId;
        }
      });
      if (this.switchTagId == name) return false;
      this.expertListFinished = false;
      this.expertListLoading = true;
      this.expertAnswerList = [];
      this.expertAnswerParams.page = 1;
      this.expertAnswerParams.total = 0
      this.curTagId = name;
      this.switchTagId = name;
      this.getQuestionList(this.tabClassId);
    },
    switchPageList: function (item) {
      this.tagsName = item.name;
      $(".tagAllList").slideUp(300);
      $(".tagAllListMask").fadeOut(100);
      $("body").css({ position: "initial", top: "auto" });
      $(window).scrollTop(this.winScrollTop);
      if ($(".van-sticky").css("position") == "fixed") {
        $(".van-tabs__content").css(
          "min-height",
          document.body.clientHeight - $(".van-sticky").height() + "px"
        );
        if ($(".searchBox").css("position") == "fixed") {
          $(".van-tabs__content").css(
            "min-height",
            document.body.clientHeight -
            $(".van-sticky").height() -
            $(".searchBox").height() +
            "px"
          );
        }
      }
      if (this.switchTagId == item.fnTagId) return false;
      this.expertAnswerList = [];
      this.expertAnswerParams.page = 1;
      this.expertAnswerParams.total = 0
      this.expertListFinished = false;
      this.expertListLoading = true;
      this.curTagId = item.fnTagId;
      this.switchTagId = item.fnTagId;
      this.tabClassId = item.fnTagId; // tabClassId
      this.getQuestionList(this.curTagId);
    },
    // 返回上一页
    goBack: function () {
      $(".expert-content").css("marginTop", "0");
      $(".expertOnlineList").css("overflow", "auto");
      $(".tagAllListMask").css("display", "none");
      if (window.history.length > 1 && this.getCookie("fromPath")) {
        this.$router.go(-1)
      } else {
        this.$router.push("/home");
      }
    },
    // 搜索
    onSearch: function () {
      if (this.searchText !== "") {
        this.recordList = this.searchText;
        var historyVal = [];
        if (localStorage.getItem("expertSearchList")) {
          localStorage.getItem("expertSearchList").split(",").forEach(item => {
            historyVal.push(item.length > 8 ? item.slice(0, 8) + "..." : item);
          });
        }
        var historyFlag = false;
        historyVal.forEach(item => {
          if (item == this.searchText) {
            historyFlag = true;
          }
        });
        sensors.track("SentSearch", {
          key_word: this.searchText,
          is_history: historyFlag,
          search_number: this.expertAnswerList.length
        });
      }
    },
    // 搜索框值发生改变
    searchInput: function () {
      if (this.searchText == "") {
        this.layerFloatShowExpert = false;
      } else if (this.searchText.length >= 50) {
        this.searchText = this.searchText.slice(0, 50);
      }
    },
    // 取消搜索
    onCancel: function () {
      this.searchText = "";
      this.layerFloatShowExpert = true;
      this.isCancelExpert = false;
    },
    // 搜索框获取焦点
    searchFocus: function (e) {
        this.$router.push({
        path: "/search",
        query: {
          searchIndex: "expertOnline",
        },
      });
      sessionStorage.setItem("searchVal", "expertOnline");
      var pageName = this.$route.meta.title;
      sensors.track("ClickSearch", {
        page_name: pageName
      });
    },
    // udesk
    contactServiceHander () {
      if (this.is_weixin()) {
        //微信中
        if (
          this.getCookie("xmh_openid") == null ||
          this.getCookie("xmh_openid") == ""
        ) {
          //判断有没有openId
          location.href =
            "/xmh/v2/wechat/oauth2/authorize?url=" +
            encodeURIComponent(window.location.href);
        } else {
          contactService("13370");
        }
      }
    },
    // gio专家在线流量位埋点
    expertClickGio: function (gioParams) {
      gio("track", "expertOnlineClick", {
        floor_var: gioParams.floor_var,
        position_var: gioParams.position_var,
        contentName_var: gioParams.contentName_var
      });
    },
    // 点击分类问答流量位
    toExpertDetail: function (expert, item) {
      this.expertClickGio({
        floor_var: "问答分类",
        position_var: item.name,
        contentName_var: expert.question
      });
      gio("track", "QAClick", {
        QATitle_var: expert.question,
        QALabel_var: expert.tagNames,
        page_var: "专家在线"
      });
      var that = this;
      setTimeout(function () {
        that.$router.push({ path: "/expertOnline/detail/" + expert.id });
      }, 200);
    },
    // 点击进去专家介绍页
    toExpertInfo: function (expert) {
      this.$router.push({
        path: "/expertOnline/expertLists/" + expert.expertId
      });
    },
    getCookie,
    is_weixin
  },
  watch: {
   $route(to, from){
     if(from.name=="questionDetail") {
      this.getQuestionList(this.tabClassId || this.switchTagId);
     }
     if(from.name=='expertOnlineSearch'){
      this.searchText = "";
      this.layerFloatShowExpert = true;
      this.isCancelExpert = false;
     }
   }
  }
};
</script>
